/* XtremeSkins customiser guard — TEST COPY ONLY.
 * Install only in the unpublished "Customiser Bug Investigation" theme.
 * Based on the product-form.js supplied in this conversation.
 * Not a confirmed root-cause fix or a store-wide checkout validation.
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name="id"]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
      this.useSuccessMessage = this.cart && this.cart.tagName.toLowerCase() !== 'cart-notification' && window.showAddToCartMessage;
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.clearCustomisationError();

      // Validate before locking the button, showing the spinner or sending a request.
      let request;
      try {
        request = this.prepareRequestConfig();
      } catch (error) {
        console.warn('[XtremeSkins customiser] Add to Cart stopped:', error);
        this.showCustomisationError(error.name === 'XtremeSkinsCustomisationError'
          ? error.message
          : 'We could not prepare your item. Please refresh this product page and try again.');
        return;
      }
      const formData = request.formData;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(`${routes.cart_add_url}`, request.config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status && response.status != 422) {
            document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message
            }}));
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if(!this.error) {
            if(response.status != 422) {
              this.error = false;
              if(this.useSuccessMessage) {
                pushSuccessMessage(window.cartStrings.success);
              }
              this.completeAddToCartAction(response, formData.get('id'));
            } else {
              this.handleErrorMessage(response.description);
              this.handle422Error(formData.get('id'));
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    prepareRequestConfig() {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      this.applyCustomisationProperties(formData);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      return {
        config: config,
        formData: formData
      };
    }

    /*
     * XtremeSkins preview-only submission guard, 26 October 2026.
     * Uses the supplied customiser markup. It does not change variant IDs,
     * prices, selected materials, image previews or native checkout buttons.
     * Only the AJAX path through this ProductForm class is covered.
     */
    applyCustomisationProperties(formData) {
      const fail = (message) => {
        const error = new Error(message);
        error.name = 'XtremeSkinsCustomisationError';
        throw error;
      };
      const refreshMessage = 'We couldn\'t confirm your customisation. Please refresh this product page, reselect your options and try again.';
      const normalise = (value) => String(value == null ? '' : value).trim().toLowerCase().replace(/[\s_]+/g, '_');
      const partsOf = (variant) => String(variant.title || '').split(/[+/]/).map(normalise).filter(Boolean);
      const isCustomVariant = (variant) => {
        const options = Array.isArray(variant.options) ? variant.options : [];
        return options.some((option) => normalise(option) === 'custom') || partsOf(variant).includes('custom');
      };

      // Do not use document-wide customiser controls: another product can be
      // present in recommendations or in a quick-add drawer on the same page.
      const scope = this.closest('quick-add-drawer, quick-add-modal, .shopify-section') || this.parentElement;
      if (!scope) fail(refreshMessage);
      const panels = Array.from(scope.querySelectorAll('[id="CustomizationViews"]'));
      const propertyBoxes = Array.from(scope.querySelectorAll('[id="LineProperties"]'));
      const hasLocalCustomiser = panels.length > 0 || propertyBoxes.length > 0;
      const variantId = String(formData.get('id') || '');
      if (!/^\d+$/.test(variantId) || formData.getAll('id').length !== 1) fail(refreshMessage);

      // Product metadata may sit outside the form. Read by exact variant ID,
      // never by "the first product on the page". No external request is made.
      const matches = [];
      document.querySelectorAll('[data-product-json]').forEach((element) => {
        try {
          const data = JSON.parse(element.textContent);
          if (!data || !Array.isArray(data.variants)) return;
          const variant = data.variants.find((item) => String(item.id) === variantId);
          if (variant) matches.push({ element, data, variant });
        } catch (_) {
          // Missing/invalid metadata is handled below, not silently repaired.
        }
      });
      const modeSelects = Array.from(scope.querySelectorAll('variant-selects select')).filter((select) =>
        Array.from(select.options).some((option) => normalise(option.value) === 'custom')
      );
      const customModeShown = modeSelects.some((select) => normalise(select.value) === 'custom');
      const localMatches = matches.filter((match) => scope.contains(match.element));
      const candidates = localMatches.length ? localMatches : matches;
      if (!candidates.length) {
        if (hasLocalCustomiser || customModeShown) fail(refreshMessage);
        return; // Ordinary forms with no evidence of this customiser: unchanged.
      }
      const signature = ({ data, variant }) => [String(data.id), isCustomVariant(variant), partsOf(variant).sort().join('|')].join(':');
      if (new Set(candidates.map(signature)).size !== 1) fail(refreshMessage);
      const { variant } = candidates[0];
      const isCustom = isCustomVariant(variant);

      // A colour-mode switch and a variant refresh can disagree temporarily.
      // Block rather than submit a different variant/price from the UI.
      if (modeSelects.length > 1) fail(refreshMessage);
      if (modeSelects.length === 1 && customModeShown !== isCustom) {
        fail('Your product options have not finished updating. Please reselect your options, then try Add to Cart again.');
      }
      if (!isCustom) return;
      if (variant.available === false) fail('This custom combination is unavailable. Please choose another combination.');
      if (panels.length !== 1 || propertyBoxes.length !== 1) fail(refreshMessage);
      const panel = panels[0];
      const propertyBox = propertyBoxes[0];
      const selects = Array.from(panel.querySelectorAll('select.material-select'));
      if (!selects.length) fail(refreshMessage);

      const fields = Array.from(propertyBox.querySelectorAll('input[name^="properties["]'));
      const managedNames = new Set(fields.map((field) => field.name));
      const propertyForId = (id) => {
        const matching = fields.filter((field) => field.id === id);
        if (matching.length !== 1 || !/^properties\[[^\]]+\]$/.test(matching[0].name)) fail(refreshMessage);
        return matching[0].name;
      };
      const entries = new Map();
      const selectedTypes = [];
      const put = (name, value) => {
        if (entries.has(name) || !value) fail(refreshMessage);
        entries.set(name, value);
      };
      selects.forEach((select) => {
        const option = select.options[select.selectedIndex];
        const value = option ? String(option.value).trim() : '';
        const type = option ? normalise(option.getAttribute('data-type')) : '';
        if (!value || normalise(value) === 'unselected' || type === 'unselected') return;
        if (!type || select.matches(':disabled') || option.disabled || option.parentElement?.disabled) fail(refreshMessage);
        const view = option.getAttribute('data-view') || select.getAttribute('data-view');
        if (!view) fail(refreshMessage);
        const name = propertyForId(`${view}-line`);
        selectedTypes.push(type);
        put(name, value.replace(/_/g, ' '));
      });

      const gels = Array.from(panel.querySelectorAll('[id="GelSelect"]'));
      const gelFields = fields.filter((field) => field.classList.contains('property-gel-line'));
      if (gels.length > 1 || gelFields.length > 1 || gels.length !== gelFields.length) fail(refreshMessage);
      if (gels.length && gels[0].checked) {
        if (gels[0].matches(':disabled')) fail(refreshMessage);
        selectedTypes.push('gel');
        put(propertyForId(gelFields[0].id), 'yes');
      }

      const expectedTypes = partsOf(variant).filter((part) => part !== 'custom');
      const actual = selectedTypes.slice().sort();
      const expected = expectedTypes.slice().sort();
      if (!expected.length || new Set(actual).size !== actual.length || new Set(expected).size !== expected.length) fail(refreshMessage);
      if (actual.length !== expected.length || actual.some((type, index) => type !== expected[index])) {
        fail('Your selected sections do not match this product option. Please reselect the sections and finishes you want, then try Add to Cart again.');
      }

      const logos = Array.from(panel.querySelectorAll('[id="SetLogo"]'));
      const logoFields = fields.filter((field) => field.classList.contains('property-logo-line'));
      if (logos.length > 1 || logoFields.length > 1 || logos.length !== logoFields.length) fail(refreshMessage);
      if (logos.length) {
        if (logos[0].matches(':disabled')) fail(refreshMessage);
        put(propertyForId(logoFields[0].id), logos[0].checked ? 'yes' : 'no');
      }

      // Work on this request only. Disabled/unassociated hidden fields cannot
      // drop these values, and stale values for unselected sections are removed.
      // Unrelated properties (for example a customer note) are retained.
      managedNames.forEach((name) => formData.delete(name));
      entries.forEach((value, name) => formData.set(name, value));
    }

    clearCustomisationError() {
      if (this.customisationErrorElement) this.customisationErrorElement.hidden = true;
    }

    showCustomisationError(message) {
      if (!this.customisationErrorElement) {
        const element = document.createElement('p');
        element.className = 'xtremeskins-customisation-error';
        element.setAttribute('role', 'alert');
        element.setAttribute('aria-live', 'assertive');
        element.style.cssText = 'margin:0 0 1rem;white-space:normal;';
        this.form.prepend(element);
        this.customisationErrorElement = element;
      }
      this.customisationErrorElement.textContent = message;
      this.customisationErrorElement.hidden = false;
    }

    handle422Error(variantId) {
      const sections = this.cart.getSectionsToRender().map((section) => section.id);
      const uniqueSections = sections.filter((item, index) => sections.indexOf(item) === index);
      fetch(`${window.location.pathname}?sections=${uniqueSections.join(",")}`)
        .then((response) => response.json())
        .then(response => {
          const finalResponse = {
            sections: response
          };
          this.completeAddToCartAction(finalResponse, variantId);
        });
    }

    completeAddToCartAction(response, variantId) {
      const quickAddDrawer = this.closest('quick-add-drawer');
      if (quickAddDrawer) {
        document.body.addEventListener('drawerClosed', () => {
          setTimeout(() => { this.cart.renderContents(response) });
        }, { once: true });
        quickAddDrawer.close();
      } else {
        this.cart.renderContents(response);
      }
      document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {
        productVariantId: variantId,
        source: 'product-form',
        cartData: response
      }}));
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        if(this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
